async function getSegmentMap() {
  const cxid = window.Eacs.cxid;
  if (!cxid) {
    return null;
  }
  
  return await fetch(
    `/a/eacs/sh-app/promos/promo-segments-details?cxid=${cxid}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  ).then(function (res) {
    return res.json();
  }).then(function(res){
    // throw "yess"
    if (Object.keys(res).length > 0){
      return res
    }
    return null
  }).catch(function(err){
    console.error("err",err);
    return null;
  });

}

async function segmentedBadgeMechanicsInsert() {
  const divBadges = document.getElementsByClassName("eacs-badge");
  // const mechanicsContainers2 = document.getElementsByClassName("promo-placeholder");
  if (!window.Eacs.Segment.Map) {
      for (const divBadge of divBadges) {
        divBadge.innerHTML = window.Eacs.Segment.Backup.get(divBadge) ?? ""
      }
      // for (const mechanicsContainer of mechanicsContainers2) {
      //   mechanicsContainer.innerHTML = window.Eacs.Segment.Backup.get(mechanicsContainer)
      // }
      return;
  }


  for (const divBadge of divBadges) {
    JSON.parse(divBadge.dataset.eacsSegmentBadges);
    let badgesDetails;
    if (!divBadge?.dataset?.eacsSegmentBadges) {
      continue;
    }
    if (
      typeof divBadge.dataset.eacsSegmentBadges === "string" &&
      divBadge.dataset.eacsSegmentBadges.trim()
    ) {
      badgesDetails = JSON.parse(divBadge.dataset.eacsSegmentBadges);
    } else {
      badgesDetails = divBadge.dataset.eacsSegmentBadges;
    }
    if (Array.isArray(badgesDetails) && badgesDetails.length > 1) {
      badgesDetails.shift();
    } else {
      continue;
    }

    for (const bDetails of badgesDetails) {
      const promo = window.Eacs.Segment.Map[bDetails.p];
      if (!promo) continue;
      const badgeTag = divBadge.firstElementChild;
      if (
        badgeTag?.dataset?.eacsBadgePriority === null ||
        badgeTag?.dataset?.eacsBadgePriority === undefined ||
        Number(badgeTag?.dataset?.eacsBadgePriority) >= bDetails.pr
      ) {
        divBadge.innerHTML = `<h6 class="product-badge--${promo.color}" data-eacs-badge-priority="${bDetails.pr}">${promo.badge}</h6>`;
      }
    }
  }

  // for (const mDetails of window.Eacs.Segment.Mechanics) {
  //   const mechanicsContainers =
  //     document.getElementsByClassName("c");
  //   const promo = window.Eacs.Segment.Map[mDetails.p];
  //   if (!promo) continue;
  //   for (const mechanicsContainer of mechanicsContainers) {
  //     if (mechanicsContainer?.tagName?.toLowerCase() !== "ul") continue;
  //     const li = document.createElement("li");
  //     li.innerHTML = promo.mechanics;
  //     if (promo.mechanics) mechanicsContainer.appendChild(li);
  //   }
  // }
}

segmentMap = getSegmentMap();

document.addEventListener("DOMContentLoaded",async function () { 
  const divBadges = document.getElementsByClassName("eacs-badge");
  // const mechanicsContainers = document.getElementsByClassName("promo-placeholder");
  window.Eacs.Segment.Backup = new Map();
  for (const divBadge of divBadges) {
    window.Eacs.Segment.Backup.set(divBadge,divBadge.innerHTML)
  }

  // for (const mechanicsContainer of mechanicsContainers) {
  //   window.Eacs.Segment.Backup.set(mechanicsContainer,mechanicsContainer.innerHTML)
  // }

  if (!window?.Eacs?.cxid) {
      window.Eacs.Segment.Map = null
      localStorage.removeItem("segment_map")
      return
  }
  const sMapStr = localStorage.getItem("segment_map")
  if(sMapStr){
    const sMap = JSON.parse(sMapStr)
    window.Eacs.Segment.Map = sMap 
    segmentedBadgeMechanicsInsert();
  }

  setTimeout(async function(){
    console.log("timeout ebms")
    window.Eacs.Segment.Map = await segmentMap
    segmentedBadgeMechanicsInsert();
    if(window.Eacs.Segment.Map){
      localStorage.setItem("segment_map", JSON.stringify(window.Eacs.Segment.Map))
    }else{
      localStorage.removeItem("segment_map")
    }
  }, 1);



});